import { Controller } from "@hotwired/stimulus";
import { WebAuthnSigner } from "@dfns/sdk-browser";
import { storage } from "../../../storageconstants";
import { debugError, debugLog, syncCheckoutOverview } from "../../../utils";

export default class FastTrackOtpApproveController extends Controller {
  static values = {
    code:                 String,
    session:              String,
    address:              String,
    challenge:            String,
    approval:             String,
    tokenContractAddress: String,
    networkName:          String,
    amountDisplay:        String,
  }

  initialize() {
    this.attestation = null;
    this.signing = false;
    this.domain = JSON.parse(sessionStorage.getItem(storage.DOMAIN));
  }

  connect() {
    this.hideLoadingScreen();
    this.challenge = JSON.parse(this.challengeValue);
    this.approval = JSON.parse(this.approvalValue);
    syncCheckoutOverview({
      networkName:   this.networkNameValue,
      amountDisplay: this.amountDisplayValue,
    });

    debugLog("FastTrackOtpApproveController connected with:", {
      "code": this.codeValue,
      "session": this.sessionValue,
      "address": this.addressValue,
      "tokenContractAddress": this.tokenContractAddressValue,
      "challenge": this.challenge,
    });
  }

  async sign() {
    if (this.signing) {
      debugLog("FastTrackOtpApprove sign() ignored — already in progress");
      return;
    }
    this.signing = true;
    this.showLoadingScreen("Authorizing spending...");
    try {
      if (!this.challenge) throw new Error("No approve challenge available to sign");
      if (!this.domain)    throw new Error("Domain data not available");

      debugLog("Starting WebAuthn signing for fast-track approve challenge");

      const webauthn = new WebAuthnSigner({
        relyingParty: {
          id:   this.domain.domain,
          name: this.domain.company,
        },
      });
      this.attestation = await webauthn.sign(this.challenge);

      this.showLoadingScreen("Confirming authorization on-chain...");
      this.submitApprove();
    } catch (error) {
      this.hideLoadingScreen();
      debugError("Error during fast-track approve WebAuthn signing:", error);
    } finally {
      this.signing = false;
    }
  }

  submitApprove() {
    const form = document.getElementById("frame-post-form");
    const challengeEl = document.getElementById("form_challengeIdentifier");
    if (!form || !challengeEl) {
      debugLog("FastTrackOtpApprove submit aborted — form already replaced");
      return;
    }
    challengeEl.value = this.challenge.challengeIdentifier;
    document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
    document.getElementById("form_session").value = this.sessionValue;
    document.getElementById("form_tokenContractAddress").value = this.tokenContractAddressValue;
    document.getElementById("form_approvalData").value = JSON.stringify(this.approval);
    form.action = `/${this.codeValue}/sign-fast-track-approve`;
    form.requestSubmit();
  }

  showLoadingScreen(message) {
    this.dispatch("showLoadingScreen", { detail: { text: message || "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
